export class DivisionInfo {
  DivisionId: number
  DivisionCode: string
  DivisionName: string
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  CreateByDisplay: string
  UpdateDate: string
  UpdateBy: string
  rowOFFSet: number
  rowFetch: number
}
